import {
  formatPercentageValue,
  createKpiTileItem,
} from '../../../../utils/helper';
import { KpiHandler, UserInteractionData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const downtimeFaultsAdoption: KpiHandler = {
  type: 'KpiTile',
  handler: (data: UserInteractionData): KpiData => {
    const { downtimeFaultsAdoption, downtimeFaultsAdoptionDelta } = data;

    const formattedValue = formatPercentageValue(downtimeFaultsAdoption);
    const tag = {
      text: formatPercentageValue(Math.abs(downtimeFaultsAdoptionDelta)),
      isPositiveValue: downtimeFaultsAdoptionDelta >= 0,
      sideLabel: '',
    };

    return createKpiTileItem(
      'Downtime Updated Faults Adoption',
      formattedValue,
      downtimeFaultsAdoptionDelta ? tag : []
    );
  },
};

export default downtimeFaultsAdoption;
